import { render, staticRenderFns } from "./HorizontalParty.vue?vue&type=template&id=b3bf38e2"
import script from "./HorizontalParty.vue?vue&type=script&lang=js"
export * from "./HorizontalParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports